<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ 'OFFICE.SELECTOFFICE' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')" *ngIf="(consultant$ | async)?.office">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="container">
      <input type="text" id="officeSearch" class="form-control" [placeholder]="'OFFICE.FILTERBYNAME' | translate" aria-label="Oficina" (input)="filterOffices($event.target.value)">
    </div>

    <div class="container">
      <ng-container *ngFor="let company of companies$ | async">
        <div [id]="company.fiscalName" class="card" *ngIf="company.offices.length">
          <div class="card-header">
            <a (click)="isCompanyCollapsed(company, true)" [attr.aria-expanded]="!isCompanyCollapsed(company)" [attr.aria-controls]="'companyOfficeGroup' + company.id">
              <i class="fa fa-angle-right" [class.fa-rotate-90]="!isCompanyCollapsed(company)"></i> &nbsp; {{ company.fiscalName }}
            </a>
          </div>

          <div [id]="'companyOfficeGroup' + company.id" [ngbCollapse]="isCompanyCollapsed(company)">
            <div [id]="office.selectName" class="card" *ngFor="let office of company.offices">
              <div class="card-body" (click)="selectOffice(office)">
                {{ office.selectName | titlecase }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="modal-footer">

  </div>
</ng-template>
